import Drawer from "@material-ui/core/Drawer";
import STDrawerMenu from "../../assets/styles/organisms/drawerMenu.module.scss";
import { routes } from "../../router/Router";
import { NaviItem } from "../../types/naviItem";
import DrawerMenuButton from "../atoms/DrawerMenuButton";
import Logo from "../molecules/ImageLink";
import NaviMenu from "../molecules/NaviMenu";
import { Link } from "react-router-dom";
import { Box, Typography, makeStyles } from "@material-ui/core";
import { Person } from "@material-ui/icons";

const useStyles = makeStyles(() => ({
  myPage: {
    fontWeight: 700,
    fontSize: "14px",
  },
}));

type Props = {
  setIsOpen: (isOpen: boolean) => void;
  isOpen: boolean;
  subdomain: string;
  imageUrl: string;
  naviItems: NaviItem[];
};

const DrawerMenu: React.FC<Props> = (props: Props) => {
  const classes = useStyles();
  const hundleClick = () => {
    props.setIsOpen(!props.isOpen);
  };
  return (
    <Drawer
      anchor="right"
      open={props.isOpen}
      onClose={hundleClick}
      classes={{ paper: STDrawerMenu.drawer_menu }}
    >
      <div className={STDrawerMenu.header}>
        <Logo
          linkUrl={routes.top.path}
          imageUrl={props.imageUrl}
          className={STDrawerMenu.logo}
          alt={props.subdomain}
        />
        <DrawerMenuButton
          isOpen={props.isOpen}
          setIsOpen={hundleClick}
          subdomain={props.subdomain}
        />
      </div>
      <div className={STDrawerMenu.navi}>
        <NaviMenu naviItems={props.naviItems} className="" />
      </div>
    </Drawer>
  );
};

export default DrawerMenu;
